<div class="wrapper">
  <div id="dqChart" [ngClass]="{'special': (showPlaceholder$ | async)}" #dqChart></div>
  @if ((showPlaceholder$ | async)) {
    <div class="placeholder">
      <p>DQ graph</p>
      <mat-progress-spinner mode="indeterminate" [diameter]="30"></mat-progress-spinner>
    </div>
  }
</div>